import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import {
  CompanyCustomerInstallationsResponse,
  MigrateInstallationsQueryParams,
} from './installations-migration.model';

@Injectable()
export class InstllationsMigrationApi {
  constructor(private clientService: ClientService) {}

  /**
   * Returns list of installation that can be migrated to another customer
   * @param params
   * @param version
   */
  migrateInstallations(
    bodyParams: MigrateInstallationsQueryParams,
    version: string = 'v1'
  ): Observable<CompanyCustomerInstallationsResponse> {
    const httpParams = {};
    httpParams['oldCompanyNumber'] = bodyParams.oldCompanyNumber;
    httpParams['newCompanyNumber'] = bodyParams.newCompanyNumber;

    if (bodyParams.installationIds.length > 0) {
      httpParams['installationIds'] = bodyParams.installationIds;
    }

    const endpoint = `iot/${version}/user-management/invitations/move`;

    return this.clientService.post(endpoint, httpParams);
  }
}
